/* ---------- addtocart.js  (완전 교체본) ---------- */
document.addEventListener('DOMContentLoaded', () => {

  /* 모달 열고 닫기 */
  function openCartModal() {
    const m = document.getElementById('cartModal');
    const o = document.getElementById('blurOverlay');
    if (m && o) { m.style.display = 'block'; o.style.display = 'block'; document.body.style.overflow = 'hidden'; }
  }
  function closeCartModal() {
    const m = document.getElementById('cartModal');
    const o = document.getElementById('blurOverlay');
    if (m && o) { m.style.display = 'none'; o.style.display = 'none'; document.body.style.overflow = ''; }
  }
  window.openCartModal = openCartModal;
  window.closeCartModal = closeCartModal;
  document.getElementById('blurOverlay')?.addEventListener('click', closeCartModal);

  /* 카트 모달 렌더링 */
  function renderCartModal(cart) {
    const wrap = document.getElementById('cartModalContent');
    if (!wrap) return;
    let html = '<ul class="cart-items">';

    cart.items.forEach(item => {
      /* 라인-아이템 property 에 넣어둔 _thumb 우선 사용 */
      const thumbProp = item.properties?._thumb;
      const imageUrl  = thumbProp || item.featured_image?.url || item.image;

      const title   = item.title.split(' - ')[0];
      const price   = '€' + (item.final_line_price / 100).toFixed(0);
      const color   = item.options_with_values?.[0]?.value || '';
      const size    = item.options_with_values?.[1]?.value || '';

      html += `
        <li>
          <div class="cart-list-col cart-list-thumb">
            <a href="${item.url}" target="_parent">
              <img src="${imageUrl}" alt="${title}">
            </a>
          </div>
          <div class="cart-list-col cart-list-product">
            <div class="cart-list-name">
              <p><a href="${item.url}" target="_parent">${title}</a></p>
              ${(color || size) ? `
                <span class="cart-list-option">
                  ${color ? `<span class="option-color">Color: ${color}</span>` : ''}
                  ${size  ? `<span class="option-size">Size:  ${size }</span>` : ''}
                </span>` : ''}
              <div class="cart-list-col cart-list-price">${price}</div>
            </div>
          </div>
        </li>`;
    });

    wrap.innerHTML = html + '</ul>';
  }
  window.renderCartModal = renderCartModal;

  /* Add-to-Cart */
  function handleAddToCart(evt) {
    evt?.preventDefault();

    const miss = [...document.querySelectorAll('input[id^="option-"][id$="-hidden"]')]
                 .some(i => !i.value.trim() || i.value.trim() === '*');
    if (miss) { alert('Please select all options.'); return; }

    const variantId = document.getElementById('selected-variant-id').value;
    const qty       = +document.getElementById('quantity')?.value || 1;
    const thumbVal  = document.querySelector('[name="properties[_thumb]"]')?.value || '';

    fetch('/cart/add.js', {
      method : 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body   : JSON.stringify({
        id: variantId,
        quantity: qty,
        properties: { _thumb: thumbVal }          /* ← 썸네일 URL 을 line-item property 로 */
      })
    })
    .then(r => { if (!r.ok) throw r.statusText; return r.json(); })
    .then(() => fetch('/cart.js'))
    .then(r => r.json())
    .then(cart => { renderCartModal(cart); openCartModal(); })
    .catch(err => console.error('Add to cart error:', err));
  }
  window.handleAddToCart = handleAddToCart;

  document.getElementById('AddToCartForm')
    ?.addEventListener('submit', e => { e.preventDefault(); handleAddToCart(e); });
});